// removed by extract-text-webpack-plugin
module.exports = {"arrowsButton":"arrows__arrowsButton--31SOK","icon":"arrows__icon--1544_","fillRed":"arrows__fillRed--2CwD3","root":"arrows__root--8uYDo","fillRedImportant":"arrows__fillRedImportant--3l5gk","fillWhite":"arrows__fillWhite--3RthG","menuOpen":"arrows__menuOpen--3SwlD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Header/arrows.css
// module id = 8du/
// module chunks = 0